import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFinder: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="finder, files, os"><path d="M13.25 13.25H11.25C11.434 10.0834 11.9396 7.03576 12.7494 4M7.75 15.5C11 17.75 13 17.75 16.25 15.5M7.75 8.75V10.25M16.25 8.75V10.25M3.75 3.75V20.25H20.25V3.75H3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFinder;
